<template>
  <q-list bordered class="rounded-borders" style="max-width: 350px">
    <q-item-label header class="q-pb-none">
      More info
    </q-item-label>

    <q-item>
      <q-item-section>
        <q-item-label class="text-subtitle2 lm-link--tertiary">
          DOI URL:
          <a class="lm-link--tertiary" :href="article.doi_url" target="_blank">{{ article.doi }}</a>
          <i class="fa fa-external-link-alt q-ml-xs"></i>
        </q-item-label>
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script>
export default {
  props: {
    article: Object
  }
}
</script>
